import { useReduxState } from 'hooks';
import { htmlToPlainText } from 'shared-helpers/common';
import { AchievementAvailableActions, AchievementsTileContent } from '.';

import type { GetAchievementsRes } from 'shared-types/responses';

interface Props {
  achievement: Pick<
    GetAchievementsRes['achievements'][0],
    | 'id'
    | 'categories'
    | 'certificateAllowAdding'
    | 'certificateRequiredFromUser'
    | 'competencies'
    | 'description'
    | 'isIncompleteViewableByUser'
    | 'monthsBeforeExpiration'
    | 'owners'
    | 'pendingRequest'
    | 'title'
    | 'type'
    | 'userAccessRequireApproval'
    | 'userAttributes'
  >;
  updateAchievements: () => Promise<void>;
}

const AchievementsAvailableTile = ({
  achievement,
  updateAchievements
}: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="achievement">
      <div className="inner">
        <AchievementsTileContent achievement={achievement}>
          {achievement.description ? (
            <div className="description">
              {htmlToPlainText(achievement.description)}
            </div>
          ) : null}
        </AchievementsTileContent>
      </div>

      <div className="footer">
        <AchievementAvailableActions
          achievement={achievement}
          isInCard={true}
          onUpdate={updateAchievements}
        />
      </div>

      <style jsx>{`
        .achievement {
          background-color: white;
          border-radius: ${theme.cardBorderRadius};
          box-shadow: ${theme.cardBoxShadow};
          cursor: pointer;
          display: flex;
          flex-direction: column;
          height: 100%;
          transition: box-shadow 0.3s;
        }
        .achievement:focus,
        .achievement:hover {
          box-shadow: ${theme.cardBoxShadowActive};
        }
        .inner {
          flex-grow: 1;
          padding: 15px;
        }
        .description {
          color: ${theme.textColorLight};
          display: -webkit-box;
          font-size: 1.4rem;
          margin-top: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      `}</style>
    </div>
  );
};

export default AchievementsAvailableTile;
